import React, { useEffect, useState } from "react";
import { NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AppSidebar from "../components/app-side-bar/app-sidebar";
import AppNavBar from "../components/app-nav-bar/app-nav-bar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { removeAuthInfo } from "../store/slices/authSlice";
import logoGif from "../assets/images/logo.gif";
import "./private-route.scss";

const PrivateRoute = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [isMobile, setIsMobile] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    setIsMobile(mobileRegex.test(navigator.userAgent));
  });

  const handleLogout = () => {
    dispatch(removeAuthInfo());
    localStorage.clear();
  };

  return (
    <div className={`wrapper${isMobile ? " wrapper--mobile" : ""}`} style={{ position: "relative" }}>
      {isLoggedIn && !isMobile && <AppNavBar />}
      {isLoggedIn && !isMobile && <AppSidebar />}

      {isLoggedIn && isMobile && (
        <header className="mobile-app-bar">
          <div className="mobile-app-bar__brand">
            <div className="mobile-app-bar__logo-wrap" aria-hidden="true">
              <img src={logoGif} alt="" className="mobile-app-bar__logo" />
            </div>
            <span className="mobile-app-bar__name">Shafa EMR</span>
          </div>
          <nav className="mobile-app-bar__actions" aria-label="Mobile navigation">
            <NavLink to="/files" className="mobile-app-bar__btn">
              <FontAwesomeIcon icon={faFolderOpen} />
              <span>Files</span>
            </NavLink>
            <button
              type="button"
              className="mobile-app-bar__btn mobile-app-bar__btn--logout"
              onClick={handleLogout}
            >
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span>Logout</span>
            </button>
          </nav>
        </header>
      )}

      {isLoggedIn && isMobile && location.pathname === "/" && <Navigate to="/files" replace />}
      {isLoggedIn ? <Outlet /> : <Navigate to="/login" />}

      <aside className="control-sidebar control-sidebar-dark" />
    </div>
  );
};

export default PrivateRoute;
